var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64717 13.6329C7.74717 13.7329 7.87384 13.7795 8.00051 13.7795C8.12717 13.7795 8.25384 13.7262 8.35384 13.6329C8.54717 13.4395 8.54717 13.1195 8.35384 12.9262L4.00717 8.57952C3.68717 8.25952 3.68717 7.73952 4.00717 7.41952L8.35384 3.07286C8.54717 2.87952 8.54717 2.55952 8.35384 2.36619C8.16051 2.17286 7.84051 2.17286 7.64717 2.36619L3.30051 6.71286C2.59384 7.41952 2.59384 8.57952 3.30051 9.28619L7.64717 13.6329Z",
    fill: "#4B5565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9805 13.6329C13.0805 13.7329 13.2072 13.7795 13.3338 13.7795C13.4605 13.7795 13.5872 13.7262 13.6872 13.6329C13.8805 13.4395 13.8805 13.1195 13.6872 12.9262L9.34051 8.57952C9.02051 8.25952 9.02051 7.73952 9.34051 7.41952L13.6872 3.07286C13.8805 2.87952 13.8805 2.55952 13.6872 2.36619C13.4938 2.17286 13.1738 2.17286 12.9805 2.36619L8.63384 6.71286C7.92717 7.41952 7.92717 8.57952 8.63384 9.28619L12.9805 13.6329Z",
    fill: "#4B5565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double-arrow-left.414a7778621d55cc1fc480f1b5e974b8.svg";
export { ForwardRef as ReactComponent };